(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-helpers.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-helpers.js');
"use strict";



const toTitleCase = string => {
  'use strict';

  const smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i;
  const alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/;
  const wordSeparators = /([ :–—-])/;
  return string.split(wordSeparators).map((current, index, array) => {
    if ( 
    current.search(smallWords) > -1 && 
    index !== 0 && index !== array.length - 1 && 
    array[index - 3] !== ':' && array[index + 1] !== ':' && ( 
    array[index + 1] !== '-' || array[index - 1] === '-' && array[index + 1] === '-')) {
      return current.toLowerCase();
    }

    if (current.substr(1).search(/[A-Z]|\../) > -1) {
      return current;
    }

    if (array[index + 1] === ':' && array[index + 2] !== '') {
      return current;
    }

    return current.replace(alphanumericPattern, match => match.toUpperCase());
  }).join('');
};
svs.myProfile.react.pages.myInformation.myInformationHelpers = {
  toTitleCase
};

 })(window);